import { HttpParams } from '@angular/common/http';
import { Injectable, inject } from '@angular/core';
import { HttpApiResponse, HttpApiService, onHttpError } from '@core/http';
import { MixinBaseClass } from '@core/mixins';
import { IDType } from '@core/models/types';
import { VersionsApiMixin } from '@core/referentials';
import { uuid } from '@utils/string';
import { WizardApiPath } from '@wizard/constants';
import { WizardReferentialType } from '@wizard/types';
import { Observable, catchError } from 'rxjs';
import { ValidateBasketParams } from '../models';
import { WizardResultList, WizardResultsGroupType } from '../types';

const WizardReportsApiPath = `${WizardApiPath}/reports`;
const WizardSemanticsApiPath = `${WizardApiPath}/semantics`;
const WizardViewsApiPath = `${WizardApiPath}/views`;
const WizardApiPathByGroup: { [key in WizardResultsGroupType]: string } = {
  'Reports': WizardReportsApiPath,
  'Semantics': WizardSemanticsApiPath,
  'Views': WizardViewsApiPath
};

@Injectable({ providedIn: 'root' })
export class WizardResultsApiService extends VersionsApiMixin(MixinBaseClass) {

  private readonly apiService = inject(HttpApiService);

  constructor() {
    super();
  }

  abortAllFetching() {
    this.apiService.cancelPendingRequests();
  }

  getBasketData(validateParams: ValidateBasketParams): Observable<HttpApiResponse<WizardResultList>> {
    const { group, basket, referential, versionId, bwMigration } = validateParams;
    const url = `${WizardApiPathByGroup[group]}`;
    const params = new HttpParams()
      .append('uid', uuid())
      .append('referential', `${referential}`)
      .append('versionId', `${versionId}`)
      .append('bwMigration', `${bwMigration}`);

    return this.apiService.send(url, basket, params);
  }

  fetchLineage<T, U>(
    group: WizardResultsGroupType,
    id: IDType,
    body: T,
    referential: WizardReferentialType,
    versionId: IDType,
  ): Observable<U> {
    const params = new HttpParams()
      .append('referential', referential.toString())
      .append('versionId', versionId.toString());

    return this.apiService.send<T, U>(
      `${WizardApiPathByGroup[group]}/${id}/lineage`,
      body,
      params
    ).pipe(catchError(onHttpError.bind(this)));
  }

  override setVersionsHttpParams(params?: HttpParams): HttpParams {
    let updatedParams = super.setVersionsHttpParams(params);
    return updatedParams;
  }
}
